var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWritten(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.5012L14.9999 14.3217C14.6021 14.7567 14.0626 15.0012 13.5001 15.0012C12.9376 15.0012 12.3981 14.7567 12.0003 14.3217C11.6019 13.8875 11.0625 13.6437 10.5001 13.6437C9.93778 13.6437 9.39835 13.8875 8.99998 14.3217M2.25 15.0011H3.50591C3.87279 15.0011 4.05624 15.0011 4.22887 14.9597C4.38192 14.923 4.52824 14.8624 4.66245 14.7801C4.81382 14.6873 4.94354 14.5576 5.20296 14.2982L14.625 4.87615C15.2463 4.25483 15.2463 3.24747 14.625 2.62615C14.0037 2.00483 12.9963 2.00483 12.375 2.62615L2.95295 12.0482C2.69352 12.3076 2.5638 12.4373 2.47104 12.5887C2.3888 12.7229 2.32819 12.8692 2.29145 13.0223C2.25 13.1949 2.25 13.3784 2.25 13.7453V15.0011Z",
    stroke: "#0E0E0E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.5012L14.9999 14.3217C14.6021 14.7567 14.0626 15.0012 13.5001 15.0012C12.9376 15.0012 12.3981 14.7567 12.0003 14.3217C11.6019 13.8875 11.0625 13.6437 10.5001 13.6437C9.93778 13.6437 9.39835 13.8875 8.99998 14.3217M2.25 15.0011H3.50591C3.87279 15.0011 4.05624 15.0011 4.22887 14.9597C4.38192 14.923 4.52824 14.8624 4.66245 14.7801C4.81382 14.6873 4.94354 14.5576 5.20296 14.2982L14.625 4.87615C15.2463 4.25483 15.2463 3.24747 14.625 2.62615C14.0037 2.00483 12.9963 2.00483 12.375 2.62615L2.95295 12.0482C2.69352 12.3076 2.5638 12.4373 2.47104 12.5887C2.3888 12.7229 2.32819 12.8692 2.29145 13.0223C2.25 13.1949 2.25 13.3784 2.25 13.7453V15.0011Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.5012L14.9999 14.3217C14.6021 14.7567 14.0626 15.0012 13.5001 15.0012C12.9376 15.0012 12.3981 14.7567 12.0003 14.3217C11.6019 13.8875 11.0625 13.6437 10.5001 13.6437C9.93778 13.6437 9.39835 13.8875 8.99998 14.3217M2.25 15.0011H3.50591C3.87279 15.0011 4.05624 15.0011 4.22887 14.9597C4.38192 14.923 4.52824 14.8624 4.66245 14.7801C4.81382 14.6873 4.94354 14.5576 5.20296 14.2982L14.625 4.87615C15.2463 4.25483 15.2463 3.24747 14.625 2.62615C14.0037 2.00483 12.9963 2.00483 12.375 2.62615L2.95295 12.0482C2.69352 12.3076 2.5638 12.4373 2.47104 12.5887C2.3888 12.7229 2.32819 12.8692 2.29145 13.0223C2.25 13.1949 2.25 13.3784 2.25 13.7453V15.0011Z",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritten);
export default __webpack_public_path__ + "static/media/written.c802c1b05b8b29eb340552c5bbe7acaa.svg";
export { ForwardRef as ReactComponent };